import { Navbar, Home, About, Skills, Work, Contact } from './components';

const App = () => {
    return (
        <div>
            <Navbar />
            <Home />
            <About />
            <Skills />
            <Work />
            <Contact />
        </div>
    );
};

export default App;
